import { TSummaryCardProps } from '@cian/frontend-e2e-deal-component';
import { IActualApplicationOffers } from '../../repositories/mortgage/entities/get_actual_application_v1/ActualApplicationOffers';
import { ISearchParams } from '../../repositories/mortgage/entities/search_params/SearchParams';
import { ECalculatorBenefitProgram, ECalculatorRealEstateType } from '../../types/features/calculator';
import { transformNumToString } from '../common';

const REAL_ESTATE_TYPE_LABELS: Record<string, string> = {
  [ECalculatorRealEstateType.NewBuilding]: 'Новостройка',
  [ECalculatorRealEstateType.Secondary]: 'Вторичка',
  [ECalculatorRealEstateType.HouseBuilding]: 'Строительство дома',
};

const PROGRAM_LABELS: Record<string, string> = {
  [ECalculatorBenefitProgram.Family]: 'Семейная',
  [ECalculatorBenefitProgram.It]: 'ИТ-ипотека',
};

const formatMoney = (value: number): string => `${new Intl.NumberFormat('ru-RU').format(value)} ₽`;

interface IMapApplicationToSummaryCardOptions {
  offers?: IActualApplicationOffers | null;
  searchParams?: ISearchParams | null;
}

/** Карточка рендерится только по наличию офферов: контракт бэка гарантирует, что вместе с ними
    пришли и searchParams, но термы всё равно собираются по одному, чтобы частичный ответ не падал. */
export const mapApplicationToSummaryCard = ({
  offers,
  searchParams,
}: IMapApplicationToSummaryCardOptions): TSummaryCardProps | undefined => {
  if (!offers) {
    return undefined;
  }

  const bullets = [
    searchParams ? REAL_ESTATE_TYPE_LABELS[searchParams.realEstate.type] : undefined,
    searchParams?.benefitProgram ? PROGRAM_LABELS[searchParams.benefitProgram] : undefined,
  ];

  const terms = [
    searchParams ? { name: 'Стоимость', value: formatMoney(searchParams.objectCost) } : undefined,
    searchParams ? { name: 'Первый взнос', value: formatMoney(searchParams.downPayment) } : undefined,
    { name: 'Ставка', value: `От ${transformNumToString(offers.minRate)}%` },
    searchParams ? { name: 'Срок', value: `${searchParams.loanTermYears} лет` } : undefined,
  ];

  return {
    title: `От ${formatMoney(offers.minMonthlyPayment)}/мес`,
    subtitleBullets: bullets.filter((bullet): bullet is string => Boolean(bullet)),
    logos: offers.banksLogosPaths,
    terms: terms.filter((term): term is { name: string; value: string } => Boolean(term)),
  };
};
